import React, { useEffect, useState } from "react";
import { useDrag } from "react-dnd";
import { ItemTypes } from "../types/ItemTypes";
import '../../../../marketplace/widgets/styles/widgets.scss'

//icons
import { ReactComponent as Scanner } from "../../../../../assets/svg/solobuilder/components/scanner.svg";
import { ReactComponent as Uploader } from "../../../../../assets/svg/solobuilder/components/uploader.svg";
import { ReactComponent as Selfie } from "../../../../../assets/svg/solobuilder/components/selfie.svg";
import { ReactComponent as Button } from "../../../../../assets/svg/solobuilder/components/button.svg";
import { ReactComponent as TextInput } from "../../../../../assets/svg/solobuilder/components/textinput.svg";
import { ReactComponent as Grid } from "../../../../../assets/svg/solobuilder/components/grid.svg";
import { ReactComponent as Space } from "../../../../../assets/svg/solobuilder/components/space.svg";
import { ReactComponent as Label } from "../../../../../assets/svg/solobuilder/components/text.svg";
import { ReactComponent as Steps } from "../../../../../assets/svg/solobuilder/components/steps.svg";
import { ReactComponent as Slider } from "../../../../../assets/svg/solobuilder/components/slider.svg";
import { ReactComponent as Icon } from "../../../../../assets/svg/solobuilder/components/icon.svg";
import { ReactComponent as Otp } from "../../../../../assets/svg/solobuilder/components/otp.svg";
import { ReactComponent as Radio } from "../../../../../assets/svg/solobuilder/components/radio.svg";
import { ReactComponent as Textarea } from "../../../../../assets/svg/solobuilder/components/textarea.svg";
import { ReactComponent as Image } from "../../../../../assets/svg/solobuilder/components/image.svg";
import { ReactComponent as Pdf } from "../../../../../assets/svg/solobuilder/components/pdf.svg";
import { ReactComponent as Divider } from "../../../../../assets/svg/solobuilder/components/divider.svg";
import { ReactComponent as Modal } from "../../../../../assets/svg/solobuilder/components/modal.svg";
import { ReactComponent as IconInput } from "../../../../../assets/svg/solobuilder/components/iconInput.svg";
import { ReactComponent as Search } from "../../../../../assets/svg/solobuilder/components/search.svg";
import { ReactComponent as Avatar } from "../../../../../assets/svg/solobuilder/components/avatar.svg";
import { ReactComponent as Auth } from "../../../../../assets/svg/solobuilder/components/auth.svg";
import { ReactComponent as ExpansionPanel } from "../../../../../assets/svg/solobuilder/components/expansion.svg";
import { ReactComponent as ImageSlider } from "../../../../../assets/svg/solobuilder/components/imgslider.svg";
import { ReactComponent as SnackBar } from "../../../../../assets/svg/solobuilder/components/snackbar.svg";
import { ReactComponent as LottiePlayer } from "../../../../../assets/svg/solobuilder/components/lotti.svg";
import { ReactComponent as DatePicker } from "../../../../../assets/svg/solobuilder/components/datepicker.svg";
import { ReactComponent as ToggleButton } from "../../../../../assets/svg/solobuilder/components/toggle.svg";
import { ReactComponent as Row } from "../../../../../assets/svg/solobuilder/components/row.svg";
import { ReactComponent as Column } from "../../../../../assets/svg/solobuilder/components/column.svg";
import {ReactComponent as Container} from '../../../../../assets/svg/solobuilder/components/container-icon.svg';
import { ReactComponent as Fab } from "../../../../../assets/svg/solobuilder/components/float.svg";
import { ReactComponent as Richtext } from "../../../../../assets/svg/solobuilder/components/Richtext.svg";
import { ReactComponent as Link } from "../../../../../assets/svg/solobuilder/components/link.svg";
import Rating from "../../../../../assets/svg/solobuilder/components/RatingIcon"
import { ReactComponent as CheckBox } from "../../../../../assets/svg/solobuilder/components/checkbox.svg";
import { ReactComponent as Select } from "../../../../../assets/svg/solobuilder/components/select.svg";
import { ReactComponent as SignaturePad } from "../../../../../assets/svg/solobuilder/components/signature-pad.svg";
import { ReactComponent as SegmentControl } from "../../../../../assets/svg/solobuilder/components/segmentCtrl.svg";
import { ReactComponent as TableIcon } from "../../../../../assets/svg/solobuilder/components/tableIcon.svg";
import { ReactComponent as Stats } from "../../../../../assets/svg/solobuilder/components/stats.svg";
import { ReactComponent as RightArrow } from "../../../../../assets/svg/solobuilder/rightArrow.svg";
import { ReactComponent as Html } from "../../../../../assets/svg/solobuilder/components/Html.svg";
import { ReactComponent as QRCode } from "../../../../../assets/svg/solobuilder/components/qrcode.svg"
import { ReactComponent as TabBar } from "../../../../../assets/svg/solobuilder/components/tabBar.svg"
import { ReactComponent as Tag } from "../../../../../assets/svg/solobuilder/components/tag.svg";
import { ReactComponent as Markdown } from "../../../../../assets/svg/solobuilder/components/markdown-form-v2.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
import { setIsDrag, setStepIndex } from "../../../../../stateManager/store/onboarding/action";
import { ReactComponent as Chat } from "../../../../../assets/svg/solobuilder/components/chat-form-v2.svg";
import { ReactComponent as BarChart } from "../../../../../assets/svg/solobuilder/components/barChart.svg"
import { ReactComponent as Description } from "../../../../../assets/svg/solobuilder/components/description.svg";
import FormWizard from "../../../../../assets/svg/solobuilder/components/formWizard";
import { ReactComponent as LineChart } from "../../../../../assets/svg/solobuilder/components/barChart.svg"
import { ReactComponent as Flatlist } from "../../../../../assets/svg/solobuilder/components/flatlist.svg";
import { ReactComponent as DateRangePicker } from "../../../../../assets/svg/solobuilder/components/date-range-picker.svg";
import { ReactComponent as VideoKYC } from "../../../../../assets/svg/solobuilder/components/video-kyc.svg";


const pluginsData = [
  {
    displayName: "Commonly used",
    value: "commonlyUsed",
    fields: [
      {
        icon: <VideoKYC />,
        type: 'VideoKYC',
        label: "Video Kyc",
        desc: "Enables video call for KYC",
      },
      {
        icon: <TextInput />,
        type: 'Input',
        label: "Text input",
        desc: "Allow users to input data",
      },
      {
        icon: <Label />,
        type: 'Text',
        label: 'Label',
        desc: 'Convey information',
      },
      {
        icon: <Button />,
        type: 'Button',
        label: "Button",
        desc: "Execute your commands",
      },
      {
        icon: <Select />,
        type: 'Select',
        label: "Select",
        desc: "Allow users to select data",
      },
      {
        icon: < CheckBox />,
        type: 'CheckBox',
        label: "Check box",
        desc: "Declare a checkbox element",
      },
      {
        icon: <Textarea />,
        type: 'Textarea',
        label: "Text area",
        desc: "Declare a textarea element",
      },
      {
        icon: <Radio />,
        type: 'RadioButton',
        label: "Radio group",
        desc: "Declare a checklist element",
      },
      {
        icon: <DatePicker />,
        type: 'Datepicker',
        label: "Date picker",
        desc: "Select a date",
      },
      {
        icon: <ExpansionPanel />,
        type: 'ExpansionPanel',
        label: "Expansion panel",
        desc: "Tuck them up here",
      },
      {
        icon: <Row />,
        type: 'Row',
        label: "Row",
        desc: "Place your elements on the horizontal axis",
      },
      {
        icon: <Column />,
        type: 'Column',
        label: "Column",
        desc: "Place your elements on the vertical axis",
      },
      {
        icon: <Container />,
        type: 'Container',
        label: "Container",
        desc: "Place elements freely on both axes",
      },
      {
        icon: <Grid />,
        type: 'Grid',
        label: "Grid",
        desc: "Neatly align your items wherever you want",
      },
      {
        icon: <Image />,
        type: 'ImageViewer',
        label: "Image viewer",
        desc: "View your image",
      },
      {
        icon: <Uploader />,
        type: 'Uploader',
        label: "Upload",
        desc: "upload your documents",
      },
      {
        icon: <TabBar />,
        type: 'TabBar',
        label: "Tab bar",
        desc: "Create Tab bar",
      },
    ]
  },
  {
    displayName: "Text",
    value: "text",
    fields: [
      {
        icon: <TextInput />,
        type: 'Input',
        label: "Text input",
        desc: "Allow users to input data",
      },
      {
        icon: <Textarea />,
        type: 'Textarea',
        label: "Text area",
        desc: "Declare a textarea element",
      },
      {
        icon: <Label />,
        type: 'Text',
        label: 'Label',
        desc: 'Convey information',
      },
      {
        icon: <Richtext />,
        type: 'RichtextEditor',
        label: "Rich text editor",
        desc: "Edit your text",
      },
      {
        icon: <IconInput />,
        type: 'IconInput',
        label: 'Icon input',
        desc: 'Display icons with input',
      },
      {
        icon: <Radio />,
        type: 'RadioButton',
        label: "Radio group",
        desc: "Declare a checklist element",
      },
      {
        icon: <Slider />,
        type: 'Slider',
        label: "Slider",
        desc: "Slide to change values",
      },
      {
        icon: <DatePicker />,
        type: 'DateInput',
        label: "Date input",
        desc: "Select or type a date",
      },
      {
        icon: <DatePicker />,
        type: 'Datepicker',
        label: "Date picker",
        desc: "Select a date",
      },
      {
        icon: <Select />,
        type: 'Select',
        label: "Select",
        desc: "Allow users to select data",
      },
      {
        icon: < CheckBox />,
        type: 'CheckBox',
        label: "Check box",
        desc: "Declare a checkbox element",
      },
      {
        icon: <Tag />,
        type: 'Tag',
        label: "Tag",
        desc: "Allow users to Create Tag",
      },
      {
        icon: <DateRangePicker />,
        type: 'DateRangePicker',
        label: "Date Range Picker",
        desc: "Select a start and end date",
      }
    ]
  },
  {
    displayName: "Button",
    value: "button",
    fields: [
      {
        icon: <ToggleButton />,
        type: 'Toggle',
        label: "Toggle button",
        desc: "Switch between two states",
      },
      {
        icon: <Button />,
        type: 'Button',
        label: "Button",
        desc: "Execute your commands",
      },
      {
        icon: <Button />,
        type: 'IconButton',
        label: "Icon button",
        desc: "Button with an icon",
      },

    ]
  },
  {
    displayName: "Animation",
    value: "Animation",
    fields: [
      {
        icon: <LottiePlayer />,
        type: 'Lottie',
        label: "Lottie player",
        desc: "Play animations",
      },
    ]
  },
  {
    displayName: "Media and icons",
    value: "Media_and_icons",
    fields: [
      {
        icon: <Icon />,
        type: 'Icon',
        label: "Icon",
        desc: "Visually expressing objects, actions and ideas",
      },
      {
        icon: <Image />,
        type: 'ImageViewer',
        label: "Image viewer",
        desc: "View your image",
      },
      {
        icon: <Avatar />,
        type: 'Avatar',
        label: "Avatar",
        desc: "Circular Avatar",
      },
      {
        icon: <Pdf />,
        type: 'PdfViewer',
        label: "Pdf viewer",
        desc: "View your pdf",
      },
      {
        icon: <ImageSlider />,
        type: 'ImageSlider',
        label: "Image slider",
        desc: "Create carousel images",
      },
    ]
  },
  {
    displayName: "Layouts",
    value: "Layouts",
    fields: [
      {
        icon: <Grid />,
        type: 'Grid',
        label: "Grid",
        desc: "Neatly align your items wherever you want",
      },
      {
        icon: <Space />,
        type: 'Space',
        label: "Spacer",
        desc: "Separation of concerns",
      },
      {
        icon: <Space />,
        type: 'Spacer',
        label: "Spacer",
        desc: "Flexible spacer for rows and columns",
      },
      {
        icon: <Row />,
        type: 'Row',
        label: "Row",
        desc: "Place your elements on the horizontal axis",
      },
      {
        icon: <Column />,
        type: 'Column',
        label: "Column",
        desc: "Place your elements on the vertical axis",
      },
      {
        icon: <Container />,
        type: 'Container',
        label: "Container",
        desc: "Place elements freely on both axes",
      },
      {
        icon: <Divider />,
        type: 'Divider',
        label: "Divider",
        desc: "Split element",
      },
      {
        icon: <TableIcon />,
        type: 'Table',
        label: "Table",
        desc: "Custom table ",
      },
    ]
  },
  {
    displayName: "Navigations",
    value: "Navigations",
    fields: [
      {
        icon: <Steps />,
        type: 'Stepper',
        label: "Stepper",
        desc: "Keep track of events",
      },
      {
        icon: <Link />,
        type: 'Link',
        label: "Link",
        desc: "Add your link ",
      },
      {
        icon: <Fab />,
        type: 'FAB',
        label: "FAB",
        desc: "Trigger your primary actions",
      },
      {
        icon: <FormWizard />,
        type: 'FormWizard',
        label: "Form Wizard",
        desc: "Step-by-Step Form Completion",
      },
    ]
  },
  {
    displayName: "Overlay",
    value: "Overlay",
    fields: [
      {
        icon: <Search />,
        type: 'Autocomplete',
        label: 'Autocomplete',
        desc: 'Search for data',
      },
      {
        icon: <Modal />,
        type: 'A8Modal',
        label: 'Modal',
        desc: 'Display prompts',
      },
      {
        icon: <Modal />,
        type: 'CustomModal',
        label: 'Custom modal',
        desc: 'Display customized prompts',
      },
      {
        icon: <ExpansionPanel />,
        type: 'ExpansionPanel',
        label: "Expansion panel",
        desc: "Tuck them up here",
      },
      {
        icon: <SnackBar />,
        type: 'SnackBar',
        label: "Snack bar",
        desc: "Show notifications",
      },
    ]
  },
  {
    displayName: "Advance",
    value: "Advance",
    fields: [
      {
        icon: <Auth />,
        type: 'oAuth',
        label: "oAuth",
        desc: "Authorization",
      },
      {
        icon: <Flatlist />,
        type: 'FlatList',
        label: "Flat list",
        desc: "List items based on a template",
      },
      {
        icon: <Otp />,
        type: 'Otp',
        label: "Otp",
        desc: "authenticates a user for a authentication",
      },
      {
        icon: <Selfie />,
        type: 'Selfie',
        label: "Selfie",
        desc: "Take a Selfie",
      },
      {
        icon: <Scanner />,
        type: 'Scanner',
        label: "Scanner",
        desc: "Scan or upload documents",
      },
      {
        icon: <Uploader />,
        type: 'Uploader',
        label: "Upload",
        desc: "upload your documents",
      },
      {
        icon: <SignaturePad />,
        type: 'SignaturePad',
        label: "Signature pad",
        desc: "Add your sign ",
      },
      {
        icon: <SegmentControl />,
        type: 'SegmentControl',
        label: "Segment control",
        desc: "Control your components with segment control",
      },
      {
        icon: <Html />,
        type: 'Html',
        label: "HTML",
        desc: "HTML and CSS Editor",

      },
      {
        icon: <QRCode />,
        type: 'QRCode',
        label: "QR code",
        desc: "Generate QR ",
      },
      {
        icon: <TabBar />,
        type: 'TabBar',
        label: "Tab bar",
        desc: "Create Tab bar",
      },
      {
        icon: <Rating />,
        type: 'Rating',
        label: "Rating",
        desc: "Give your rating ",
      },
      {
        icon: <Stats />,
        type: 'StatsNumber',
        label: "Stats number",
        desc: "Add your Stats ",

      },
      {
        icon: <Stats />,
        type: 'Stats',
        label: "Stats",
        desc: "Add your Stats ",
      },
      {
        icon: <Markdown />,
        type: 'Markdown',
        label: "Markdown",
        desc: "Add your Markdown ",
      },
      {
        type: 'Toast',
        label: "Toast",
      },
      {
        icon: <Description />,
        type: 'Description',
        label: "Description",
        desc: "Custom grid with read-only text fields",
      },
      {
        icon: <VideoKYC />,
        type: 'VideoKYC',
        label: "Video Kyc",
        desc: "Enables video call for KYC",
      },
    ]
  },
  {
    displayName: "Visualization",
    value: "Visualization",
    fields: [
    {
      icon: <BarChart />,
      type: 'BarChart',
      label: "Bar chart",
      desc: "Add your Bar Chart",
    },
    {
      icon: <LineChart />,
      type: 'LineChart',
      label: "Line chart",
      desc: "Add your Line Chart",
    },
  ]
  },
  {
    displayName: "AI",
    value: "AI",
    fields: [
      {
        icon: <Chat />,
        type: 'QandA',
        label: "Q&A widget",
        desc: "Add your Stats ",
      },
    ]
  }
]


export const components = pluginsData.map((group: any, i: number) => {
  if (group.value === "commonlyUsed") {
    return {...group, fields: group.fields}
  }
  let sort: any = group?.fields?.sort((a: any, b: any) => {
    return a.label.localeCompare(b.label)
  })
  return { ...group, fields: sort }
});

const Component = (props: any) => {
  const { type, label, desc, icon } = props.component;
  const { guideVisible, info: onboardingInfo, isDrag } = useSelector((state: AppState) => state.onboarding)
  const dispatch = useDispatch()

  const [{ isDragging }, drag] = useDrag({
    item: {
      type: ItemTypes.COMPONENT,
      json: {
        type,
        label,
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    }),
    canDrag: props.isCheckedIn
  });

  const opacity = isDragging ? 0.4 : 1;

  useEffect(()=> {
    if (isDragging && guideVisible) {
      dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
      dispatch(setIsDrag(isDragging))
    } else if (guideVisible && !isDragging && isDrag) {
      dispatch(setStepIndex(onboardingInfo.stepIndex - 1))
    }
  },[isDragging])

  return (
    <div
      className={`tour_${type.toLowerCase()}_element p-2 flex items-center space-x-2 cursor-pointer hover:bg-bluebg`}
      ref={drag}
      style={{ opacity }}
    >
      <div className="flex-shrink-0">
        {icon}
      </div>
      <div>
        <div style={{ fontSize: "13px", color: "#282B31" }} className="font-medium">{label}</div>
        <div style={{ fontSize: "10px", color: "#7D7D7D" }} className="font-normal">{desc}</div>
      </div>
    </div>
  );
};

export const FormBuilder = (props: any) => {
  const [inputText, setInputText] = useState("");
  let searchHandler = (e: { target: { value: string; }; }) => {
    const lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };
  const filteredComponents = components.map((group: any, i: number) => {
    const filter: any = group?.fields?.filter((component: any) => {
      if (inputText === "") {
        return component;
      } else {
        if (group.value !== 'commonlyUsed') {
          const inputChars = inputText.toLowerCase()?.split('');
          return inputChars.every(char => component.label.toLowerCase().includes(char));
        }
      }
    })
    return { ...group, fields: filter }
  })

  return (
    <>
      <form className="sticky top-0 z-10 w-full">
        <div className="relative" style={{ margin: "10px 0px" }}>
          <div className="flex bg-white items-center justify-between rounded-lg border border-gray-300">
            <div className="flex pl-2 items-center pointer-events-none">
              <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
            </div>
            <input onChange={searchHandler} value={inputText} type="search" id="default-search" style={{width:'80%', background: "white", height: "28px" }} className="ml-2 outline-none border-0 block  text-base text-gray-900 bg-white  font-normal focus focus:outline-none dark:bg-white-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
            <button
              className="mr-2 flex outline-none items-center justify-center hover:bg-gray-100 rounded-full cursor-pointer"
              style={{ width: "24px", height: "24px"}}
              onClick={(e) => { e.preventDefault(); setInputText("") }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5 text-gray-500 dark:text-gray-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </form>
      <div style={{ backgroundColor: "#FCFCFC" }} >
        {filteredComponents.map((group: any) => {
          return (
            <Group group={group} inputText={inputText} />
          )
        })}
      </div>
    </>
  );
};

const Group = ((props: any) => {
  const { group, inputText } = props;
  const [open, setOpen] = useState<boolean>(false)
  const excludeComponents = ["toast"]
  const { guideVisible, info: onboardingInfo } = useSelector((state: AppState) => state.onboarding)
  const dispatch = useDispatch();
  useEffect(() => {
    if (inputText === "" && group.value !== "commonlyUsed") {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }, [inputText])

  useEffect(() => {
    if (group.value === "commonlyUsed") {
      setOpen(true)
    }
  },[])
  
  return (
    <>
      {
        group.fields.length ?
          <>
            <button 
              onClick={(() => {
                 setOpen(!open) 
                 if (guideVisible) {
                   dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
                 }
              })} 
              style={{ outline: "none", transition: " 0.4s", color: "#505F7B", background: "#EFF0F4", height: "28px", width: "100%", borderRadius: "6px", marginTop: "8px" }} 
              className={`${group.value}_group accordion items-center flex w-full justify-between rounded-lg  px-2 py-3 text-left text-sm font-medium  focus:outline-none focus-visible:ring  focus-visible:ring-opacity-75  ${open && "active"}`}
            >
              <span style={{ fontWeight: 600, fontSize: "12px", color: "#505F7B" }}>{group.displayName}</span>
              {
                <RightArrow className="transition duration-[600ms]" style={{ transform: open ? "rotate(90deg)":""}}></RightArrow>
              }
            </button>
            <div className="panel" style={{ maxHeight: `${open ? "108vh" : "0px"}` }}>
              {
                group?.fields?.map(((component: any) => {
                  if (!excludeComponents.includes(component.type.toLowerCase())) {
                    return <Component isCheckedIn={props.isCheckedIn} key={component.type} component={component} />
                  } else {
                    return
                  }
                }))
              }
            </div>
          </> : <></>
      }
    </>
  )
})